var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "@emotion/styled";
export { Search } from "./Search";
export { Cart } from "./Cart";
export { Close } from "./Close";
export { Menu } from "./Menu";
export const SVGContainer = forwardRef(function SVGContainer(_a, ref) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(SVG, Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" }, props, { ref: ref }, { children: children }), void 0));
});
const SVG = styled.svg(() => ({
    height: "1em",
    width: "1em",
}));
//# sourceMappingURL=index.js.map